import { SERVICE_URLS } from '../../shared/constants';
import axios from 'axios';
import { processErrorMessage } from '../../shared/functions';

export async function changePasswordUser(password, setMessage, setOpen, key, setCountdown) {
  const parameters = {
    Password: password,
    Key: key,
  };

  try {
    const response = await axios.post(
      SERVICE_URLS.ROOT + 'Security/updatePassword',
      parameters,
      {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
      }
    );

    const { success, message } = response.data;

    if (response.status === 200 && success) {
     setMessage(`
        <div style="text-align: center;">
          <div style="font-weight: bold; font-size: 1.2rem; margin-bottom: 8px;">
            ¡Clave cambiada con éxito!
          </div>
          <div>
            Te redirigiremos al inicio de sesión en<br />
            <strong><span id="countdown-value">5</span> segundos</strong>…
          </div>
        </div>
      `);
      setCountdown(5);
      setOpen(true);
    } else {
      setMessage(`
        <div style="text-align: center;">
          <div font-size: 1rem; margin-bottom: 8px;">
            ${message || "Ocurrió un problema con su cambio de clave. Por favor, comunícate con el <strong>área de Tecnología</strong> para apoyarte."}
          </div>
        </div>
      `);

      setOpen(true);
    }
  } catch (error) {
    // Intenta obtener un mensaje específico si viene del backend
    const serverMessage = error?.response?.data?.message;
    const userMessage = serverMessage || processErrorMessage(error?.response?.data) || "Ocurrió un error inesperado. Por favor, comunícate con el <strong>área de Tecnología</strong> para apoyarte.";
    setMessage(`
      <div style="text-align: center;">
        <div font-size: 1rem; margin-bottom: 8px;">
          ${userMessage}
        </div>
      </div>
    `);
    setOpen(true);
  }
}
